module.exports = __webpack_public_path__ + "img/user-out-old.7a068ad3.svg";